import { RoLessonQuizStatsEntity } from "../../../../meta-data/app-meta-data.service";

export interface ModuleOverviewEntity extends RoLessonQuizStatsEntity {
    AverageQuizPercentage: number;
    AverageTime: number;
    AverageTimePerSession: number;
    TotalTakeCount: number;
    TotalPassCount: number;
    TotalFailCount: number;
    
    // Populated during post-processing
    RetakeRatePercentage?: number;
    AverageTimePerSessionFormatted?: string;
    AverageTimeFormatted?: string;
} 

export enum ModuleOverviewAggregateFields {
    AverageQuizPercentage = 'AverageQuizPercentage',
    RetakeRatePercentage = 'RetakeRatePercentage',
    AverageTime = 'AverageTime',
    AverageTimePerSession = 'AverageTimePerSession',
    TotalTakeCount = 'TotalTakeCount',
    TotalPassCount = 'TotalPassCount',
    TotalFailCount = 'TotalFailCount',
}